import * as React from 'react';
import { Grid, Pagination, TablePagination } from '@mui/material';
import { GridApiContext, GridSelectedRowCount, selectedGridRowsCountSelector, useGridApiContext, useGridSelector, useGridState } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';

export const dataGridStyles = makeStyles({
    noFlexFooter: {
        display: 'block'
    }
})

const useStyles = makeStyles({
    center: {
        display: 'flex',
        justifyContent: 'center',
    },
    right: {
        display: 'flex',
        justifyContent: 'end',
    },
    hidden: {
        display: 'none'
    }
});

export interface CustomPaginationProps {
    rowsPerPageOptions: number[]
}

export function CustomTablePagination(props: CustomPaginationProps) {
    const classes = useStyles();

    const apiRef = useGridApiContext();
    const { state } = apiRef.current

    const rootElement = apiRef.current.rootElementRef;

    const apiRefs = React.useContext(GridApiContext);
    const selectedRowCount = useGridSelector(apiRef, selectedGridRowsCountSelector);

    const selectedRowCountElement =
        selectedRowCount > 0 ? (
            <GridSelectedRowCount selectedRowCount={selectedRowCount} />
        ) : (
            <div />
        );

    return (
        <Grid container>

            <Grid item lg={4} md={4} xs={12}>
                {selectedRowCountElement}
            </Grid>

            <Grid item lg={4} md={4} xs={12}>
                <Pagination
                    size={'small'}
                    className={classes.center}
                    color="primary"
                    count={state.pagination.pageCount}
                    page={state.pagination.page + 1}
                    onChange={(event, value) => apiRef.current.setPage(value - 1)}
                    showFirstButton showLastButton
                />
            </Grid>

            <Grid item lg={4} md={4} xs={12}>
                <TablePagination
                    component={"div"}
                    size='small'
                    className={classes.right}
                    count={state.pagination.rowCount}
                    onPageChange={(event, value) => apiRef.current.setPage(value)}
                    page={state.pagination.page}
                    rowsPerPage={state.pagination.pageSize}
                    onRowsPerPageChange={(event) => apiRef.current.setPageSize(parseInt(event.target.value))}
                    backIconButtonProps={{ style: { display: 'none' } }}
                    nextIconButtonProps={{ style: { display: 'none' } }}
                    labelRowsPerPage={'Rows'}
                    rowsPerPageOptions={props.rowsPerPageOptions}
                />
            </Grid>

        </Grid>
    );
}